var tpStarsAllFunction,tpSelectTracking,tpSubmitForm,tpTrackingAnother,tploadStyleByWidth,tpPageCommunication;



(function(w,t,u,p,s,tp,_self){
	class trackingmore{
		
		// Start execution after the page is loaded
		constructor(){
			// css loading
			let version = "1.002";
			let cssname = "20200114";
			let cssurl = "https:" + s + "/track/css/" + cssname + ".css?time=" + version;
			this.appendCssLinkStyle(cssurl);
			this.isChangeUrl = true;
			this.tp = t.getElementById(tp);
			this.key = this.tp.getAttribute("data-key");
			this.num = this.tp.getAttribute("data-number");
			this.ord = this.tp.getAttribute("data-order");
			this.email = this.tp.getAttribute("data-email");
			this.key = this.key ? this.trimEncode(this.key) : "";
			this.getParamsTracking();
			this.num = this.num ? this.trimEncode(this.num) : "";
			this.ord = this.ord ? this.trimEncode(this.ord) : "";
			this.email = this.email ? this.trimEncode(this.email) : "";
			this.pattern_email = new RegExp("^[A-Za-z0-9]+([._\\-\+]*[A-Za-z0-9])*@([A-Za-z0-9]+[-a-z0-9A-Z]*[A-Za-z0-9]+.){1,63}[A-Za-z0-9]+$");
			this.pattern_number = /^[0-9a-z-_]{5,}$/i;
			this.width_class = [
				{ name : "tp-xx-container", width : 600},
				{ name : "tp-xs-container", width : 767},
				{ name : "tp-sm-container", width : 997},
				{ name : "tp-md-container", width : 1199},
				{ name : "tp-lg-container", width : 1399},
			];
			this.hidden = "tp-hidden";
			this.input_list = "tp-form-input-list";
			this.tracking_detail = "tp-tracking-detail";
			this.tracking_form = "tp-tracking-form-parent";
			this.loading_form = "tp-form-loading";
			this.tab_active = "tp-tab-active";
			this.form_tab_item = "tp-form-tab-item";
			this.thanks_show = "tp-thanks-show";
			this.history_fixed = "tp-history-fixed";
			this.progress_parent = "tp-progress-parent";
			this.tracking_description = "tp-tracking-description";
			this.tracking_list = "tp-tracking-list";
			this.cursor_defalt = "tp-cursor-defalt";
			this.input_arr = [];
			this.isTrackingVisual = typeof visualCommunication === 'function' ? true : false;
			this.svgAllList = {
				'1001' : '<svg style="height: 35px;width: 35px" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M17 18c-.551 0-1-.449-1-1 0-.551.449-1 1-1 .551 0 1 .449 1 1 0 .551-.449 1-1 1zM4 17c0 .551-.449 1-1 1-.551 0-1-.449-1-1 0-.551.449-1 1-1 .551 0 1 .449 1 1zM17.666 5.841L16.279 10H4V4.133l13.666 1.708zM17 14H4v-2h13a1 1 0 0 0 .949-.684l2-6a1 1 0 0 0-.825-1.308L4 2.117V1a1 1 0 0 0-1-1H1a1 1 0 0 0 0 2h1v12.184A2.996 2.996 0 0 0 0 17c0 1.654 1.346 3 3 3s3-1.346 3-3c0-.353-.072-.686-.184-1h8.368A2.962 2.962 0 0 0 14 17c0 1.654 1.346 3 3 3s3-1.346 3-3-1.346-3-3-3z"></path></svg>',
				'1100' : '<svg style="height: 35px;width: 35px" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M19.901 4.581c-.004-.009-.002-.019-.006-.028l-2-4A1.001 1.001 0 0 0 17 0H3c-.379 0-.725.214-.895.553l-2 4c-.004.009-.002.019-.006.028A.982.982 0 0 0 0 5v14a1 1 0 0 0 1 1h18a1 1 0 0 0 1-1V5a.982.982 0 0 0-.099-.419zM2 18V6h7v1a1 1 0 0 0 2 0V6h7v12H2zM3.618 2H9v2H2.618l1-2zm13.764 2H11V2h5.382l1 2zM9 14H5a1 1 0 0 0 0 2h4a1 1 0 0 0 0-2m-4-2h2a1 1 0 0 0 0-2H5a1 1 0 0 0 0 2"></path></svg>',
				'2' : '<svg style="height: 35px;width: 35px" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M17.816 14c-.415-1.162-1.514-2-2.816-2s-2.4.838-2.816 2H12v-4h6v4h-.184zM15 16c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zM5 16c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zM2 4h8v10H7.816C7.4 12.838 6.302 12 5 12s-2.4.838-2.816 2H2V4zm13.434 1l1.8 3H12V5h3.434zm4.424 3.485l-3-5C16.678 3.185 16.35 3 16 3h-4a1 1 0 0 0-1-1H1a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h1.185C2.6 17.162 3.698 18 5 18s2.4-.838 2.816-2h4.37c.413 1.162 1.512 2 2.814 2s2.4-.838 2.816-2H19a1 1 0 0 0 1-1V9c0-.18-.05-.36-.142-.515z"></path></svg>',
				'3' : '<svg style="height: 35px;width: 35px" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M10 0C5.589 0 2 3.589 2 8c0 7.495 7.197 11.694 7.504 11.869a.996.996 0 0 0 .992 0C10.803 19.694 18 15.495 18 8c0-4.412-3.589-8-8-8m-.001 17.813C8.478 16.782 4 13.296 4 8c0-3.31 2.691-6 6-6s6 2.69 6 6c0 5.276-4.482 8.778-6.001 9.813M10 10c-1.103 0-2-.897-2-2s.897-2 2-2 2 .897 2 2-.897 2-2 2m0-6C7.794 4 6 5.794 6 8s1.794 4 4 4 4-1.794 4-4-1.794-4-4-4"></path></svg>',
				'4' : '<svg style="height: 35px;width: 35px" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M10 18c-4.411 0-8-3.589-8-8s3.589-8 8-8 8 3.589 8 8-3.589 8-8 8m0-14c-3.309 0-6 2.691-6 6s2.691 6 6 6 6-2.691 6-6-2.691-6-6-6m-1 9a.997.997 0 0 1-.707-.293l-2-2a.999.999 0 1 1 1.414-1.414L9 10.586l3.293-3.293a.999.999 0 1 1 1.414 1.414l-4 4A.997.997 0 0 1 9 13"></path></svg>',
			}
			_self = this;
		}
		
		// get params data auto tracking
		getParamsTracking(){
			this.trackingParams = ["tm_number","tm_order","tm_email"];
			try{
				let params = this.getUrlParams();
				if(params.tm_number){
					this.isChangeUrl = false;
					this.num = params.tm_number;
				}
				if(params.tm_order && params.tm_email){
					this.isChangeUrl = false;
					this.ord = params.tm_order;
					this.num = params.email;
				}
			}catch(e){
				//TODO handle the exception
			}
		}
		
		// Show tracking input page
		showTracking(){
			// If the specified element does not exist
			if(this.tp.length === 0) return false;
			let { host, pathname, protocol } = w.location;
			let local = this.trimEncode(JSON.stringify({ host, pathname, protocol }));
			return this.sendApiRequest(this.getDataToParams("type=show-tacking&local="+local,false),"get","",this.handleTracking);
		}
		
		// Load the tracking input page based on user settings
		handleTracking(r){
			let code = r.code ? parseInt(r.code) : 0,
				data = r.data ? r.data : {},
				message = r.message ? r.message : "";
			if(code === 200) return _self.showSuccessResponse(data);
			return _self.showErrorResponse(code,message);
		}
		
		// When responding normally
		showSuccessResponse(data){
			this.theme = data.theme ? parseInt(data.theme) : 0;
			this.tracking_way = data.tracking_way ? parseInt(data.tracking_way) : 0;
			this.translate = data.translate ? data.translate : {};
			this.auto_tracking = data.auto_tracking ? parseInt(data.auto_tracking) : 0;
			this.auto_tracking = this.auto_tracking === 1 ? true : false;
			this.img_list = data.img_list ? data.img_list : [];
			this.url_list = data.url_list ? data.url_list : [];
			this.hide_list = data.hide_list ? data.hide_list.split(',') : [];
			this.custom_text = data.custom_text ? data.custom_text : '';
			this.track_url = data.track_url ? data.track_url : '';
			this.powered = data.powered ? parseInt(data.powered) : 0;
			this.powered = this.powered === 1 ? true : false;
			this.browser = data.browser ? data.browser : '';
			this.is_allow_change_url = data.is_allow_change_url === true ? true : false;
			if(data.css){
				if(data.css.length > 0) data.css.forEach((value,key) => {
					return _self.appendCssLinkStyle(value);
				});
			}
			this.loadPageBaseSetting();
			if(this.isTrackingVisual) visualCommunication(1,this);
			if(this.auto_tracking) this.sendTrackingApi(["auto_tracking=1"],false);
			return true;
		}
		
		// Load page elements based on user settings
		loadPageBaseSetting(){
			this.str = '<div class="tp-main-content-style tp-main-content-style'+ this.theme +'">';
			// first load tracking form
			this.loadTrackingForm();
			// load the detail dom
			this.str += '<div class="tp-tracking-detail '+ this.hidden +'" id="'+ this.tracking_detail +'"></div>';
			this.str += '</div>';
			// Mount to the specified element
			this.tp.innerHTML = this.str;
			this.monitorPageWidth(null);
			return true;
		}
		
		// load tracking from
		loadTrackingForm(){
			let class_name = this.auto_tracking ? this.hidden : "";
			
			this.str += '<div class="tp-tracking-form-parent '+ class_name +'" id="'+ this.tracking_form +'">';
			
			this.str += '<div class="tp-tracking-form" data-visual="tracking-options">';
			
			// title start
			this.str += '<div class="tp-form-title">';
			this.str += '<span class="tp-f-h-1" data-controll="check_order">'+ this.translate.check_order +'</span>';
			this.str += '</div>';
			// title end
			
			class_name = this.tracking_way === 0 ? '' : this.hidden;
			
			// tab start
			
			this.str += '<div class="tp-form-tab-parent '+ class_name +'">';
			
			this.str += '<div class="'+ this.form_tab_item +' '+ this.tab_active +'" data-key="order" onclick="return tpSelectTracking(this,event);">';
			this.str += '<span data-controll="order">'+ this.translate.order_number +'</span>';
			this.str += '</div>';
			
			this.str += '<div class="'+ this.form_tab_item +'" data-key="number" onclick="return tpSelectTracking(this,event);">';
			this.str += '<span data-controll="tracking_number">'+ this.translate.tracking_number +'</span>';
			this.str += '</div>';
			
			this.str += '</div>';
			
			class_name = this.tracking_way !== 0 ? '' : this.hidden;
				
			this.str += '<div class="tp-form-description '+ class_name +'">';
			this.str += '<span data-controll="check_order_detail">'+ this.translate.check_order_detail +'</span>';
			this.str += '</div>';
			
			// tab end
			
			// input start
			this.str += '<div class="tp-form-content" id="'+ this.input_list +'">';
			
			let bool1,bool2;
			bool1 = this.tracking_way === 0 ? true : false;
			bool2 = this.tracking_way === 1 ? true : false;
			bool1 = this.tracking_way === 2 ? true : bool1;
			
			this.loadFormItem("order",this.translate.order_number,this.translate.enter_valid_order,bool1,bool2);
			
			this.loadFormItem("email",this.translate.email,this.translate.enter_valid_email,bool1,bool2);
			
			this.loadFormItem("tracking_number",this.translate.tracking_number,this.translate.enter_valid_number,!bool1,!bool2);
			
			this.str += '</div>';
			// input end
			
			// button submit start
			class_name = this.tracking_way === 0 ? "tp-m-t-12" : "tp-m-t-24";
			this.str += '<div class="tp-form-submit-parent '+ class_name +'">';
			this.str += '<button class="tp-form-submit tp-f-h-1" type="button" onclick="return tpSubmitForm(this,event)" data-controll="track">';
			this.str += '<span>'+ this.translate.track +'</span>';
			this.str += '</button>';
			this.str += '<div class="tp-loading-svg"><svg style="width: 28px;" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M10 15a1 1 0 1 1 0 2c-4.411 0-8-3.589-8-8s3.589-8 8-8a1 1 0 1 1 0 2c-3.309 0-6 2.691-6 6s2.691 6 6 6zm7.707-6.707"></path></svg></div>';
			this.str += '</div>';
			// button submit end
			
			this.str += '</div>';
			
			this.str += '</div>';
			return true;
		}
		
		// when form submit
		submitForm(r,e){
			e.stopPropagation();
			e.preventDefault();
			if(this.isTrackingVisual) return this.showTrackingDetail();
			return this.sendTrackingApi(this.getFormData(),true);
		}
		
		// send tracking api
		sendTrackingApi(params,bool){
			if(!params || params.length === 0) return false;
			this.dom_form = t.getElementById(this.tracking_form);
			this.dom_form.classList.add(this.loading_form);
			params.push("type=tracking-order");
			// send api request
			this.sendApiRequest(this.getDataToParams(params.join("&"),bool),"get","",function(res){
				return _self.handleTrackingResult(res);
			});
		}
		
		// handle tracking result
		handleTrackingResult(res){
			let code = res.code ? parseInt(res.code) : 0;
			this.dom_form.classList.remove(this.loading_form);
			// if(code !== 200) return false;
			this.tracking = res.data ? res.data : {};
			this.info = this.tracking.info ? this.tracking.info : [];
			this.progress_node = this.tracking.progress_node ? this.tracking.progress_node : [];
			this.progress_status = this.tracking.progress_status ? parseInt(this.tracking.progress_status) : 0;
			this.progress_key = this.tracking.progress_key ? parseInt(this.tracking.progress_key) : 0;
			this.estimated = this.tracking.estimated ? this.tracking.estimated : [];
			this.status_description = this.tracking.status_description ? this.tracking.status_description : "";
			this.progress_flex = [];
			this.tracking_number = this.tracking.tracking_number ? this.tracking.tracking_number : "";
			this.express_name = this.tracking.express_name ? this.tracking.express_name : "";
			this.express = this.tracking.express ? this.tracking.express : "";
			this.express_url = this.tracking.express_url ? this.tracking.express_url : "";
			this.express_img = this.tracking.express_img ? this.tracking.express_img : "";
			this.express_phone = this.tracking.express_phone ? this.tracking.express_phone : "";
			this.review = this.tracking.review ? this.tracking.review : "";
			this.ratedstars = this.tracking.ratedstars ? parseInt(this.tracking.ratedstars) : 0;
			this.preview = this.tracking.preview ? parseInt(this.tracking.preview) : 0;
			// when page in visual
			if(this.isTrackingVisual) visualCommunication(2,this);
			// load tracking detail
			return this.loadTrackingDetail();
		}
		
		// check form format
		checkFormFormat(name,value){
			switch(name){
				case "order" :
					if(!value) return false;
					break;
				case "email" :
					if(!value) return false;
					if(!this.pattern_email.test(value)) return false;
					break;
				case "tracking_number" :
					if(!value) return false;
					if(!this.pattern_number.test(value)) return false;
					break;
			}
			return true;
		}
		
		// get form data
		getFormData(){
			let data = [];
			for(let i = 0; i < this.input_arr.length; i ++){
				if(!this.input_arr[i]) continue;
				let dom = t.getElementById(this.input_arr[i]);
				let value = dom.value.trim();
				let name = dom.name;
				let sibling = dom.nextElementSibling;
				// check form format
				if(!this.checkFormFormat(name,value)){
					sibling.style.display = "block";
					return [];
				}else{
					sibling.style.display = "none";
				}
				data.push(name + "=" + this.trimEncode(value));
			}
			return data;
		}
		
		// select tracking click
		selectTracking(r,e){
			e.stopPropagation();
			if(this.isHasClassFun(r,this.tab_active)) return false;
			let tabs = r.parentNode.children;
			let len = tabs.length;
			if(len === 0) return false;
			while(len --){
				let tab = tabs[len];
				if(!this.isHasClassFun(tab,this.form_tab_item)) continue;
				if(this.isHasClassFun(tab,this.form_tab_item)) tab.classList.remove(this.tab_active);
			}
			r.classList.add(this.tab_active);
			let input_list = t.getElementById(this.input_list);
			if(input_list.length === 0) return false;
			let input_child = input_list.children;
			let length = input_child.length;
			if(length === 0) return false;
			this.input_arr = [];
			while(length --){
				let input = input_child[length];
				if(this.isHasClassFun(input,this.hidden)){
					input.classList.remove(this.hidden);
					this.pushInputId(input.children);
				}else{
					input.classList.add(this.hidden);
				}
			}
		}
		
		// push input id
		pushInputId(r){
			if(!r) return false;
			let len = r.length;
			while(len --){
				let input_child = r[len] ? r[len] : {};
				let input_name = input_child.localName ? input_child.localName : "";
				if(!input_name || input_name !== "input") continue;
				let id = input_child.id ? input_child.id : "";
				if(!id || !/^tp\-form\-/.test(id)) continue;
				this.input_arr.push(id);
			}
			return true;
		}
		
		// load form item
		loadFormItem(name,placeholder,error,bool1,bool2){
			let class_name = bool1 ? "" : this.hidden;
			let input_id = "tp-form-" + name;
			if(bool2) class_name = this.hidden;
			if(class_name === "") this.input_arr.push(input_id);
			this.str += '<div class="tp-form-input-parent '+ class_name +'">';
			this.str += '<span class="tp-form-input-placeholder" data-controll="'+ name +'">'+ placeholder +'</span>';
			this.str += '<input class="tp-form-input" name="'+ name +'" placeholder="'+ placeholder +'" id="'+ input_id +'" data-controll="'+ name +'" />';
			this.str += '<span class="tp-form-input-error" data-controll="'+ name +'-error">'+ error +'</span>';
			this.str += '</div>';
			return true;
		}
		
		// load tracking detail
		loadTrackingDetail(){
			this.str = "";
			switch(this.theme){
				case 1 : this.loadPage1theme(); break;
				case 2 : this.loadPage2theme(); break;
				default : break;
			}
			this.showTrackingDetail();
			this.dom_detail.innerHTML = this.str;
			// preview not change url
			if(this.preview === 0 && this.isChangeUrl) this.changeLocationUrl();
			// Modify the height of an element dynamically
			this.modifyElementsHeight();
			return false;
		}
		
		// Modify the height of an element dynamically
		modifyElementsHeight(){
			// modify tracking history height
			this.modifyHistoryHeight();
			// modify tracking list
			this.modifyHistoryList();
			// others
		}
		
		// modify tracking history list
		modifyHistoryList(){
			return this.modifyHeightById(this.tracking_description,this.tracking_list,-4,4);
		}
		
		// modify tracking history height
		modifyHistoryHeight(){
			return this.modifyHeightById(this.history_fixed,this.progress_parent,30,12);
		}
		
		// modify height by id
		modifyHeightById(element1,element2,h,h1){
			element1 = t.getElementById(element1);
			element2 = t.getElementById(element2);
			if(!element1 || !element2) return false;
			let height = element1.clientHeight;
			if(height === 0) height = h1;
			if(h !== 0) height += h;
			element2.style.height = 'calc(100% - '+ height +'px)';
			return true;
		}
		
		// show tacking detail
		showTrackingDetail(){
			this.dom_form.classList.add(this.hidden);
			this.dom_detail = t.getElementById(this.tracking_detail);
			this.dom_detail.classList.remove(this.hidden);
			return false;
		}
		
		// tracking another
		trackingAnother(r,e){
			let dom_form = t.getElementById(this.tracking_form);
			let dom_detail = t.getElementById(this.tracking_detail);
			dom_form.classList.remove(this.hidden);
			dom_detail.classList.add(this.hidden);
			e.stopPropagation();
			return false;
		}
		
		// Load page theme 1
		loadPage1theme(){
			// page top html
			this.loadTopHtml();
			// page middle html
			this.loadMiddleHtml(3);
			// page bottom html
			this.loadBottomHtml(3);
			return true;
		}
		
		// Load page theme 2
		loadPage2theme(){
			// use theme1
			return this.loadPage1theme();
		}
		
		// load powered by
		loadPoweredBy(){
			let class_name = this.powered ? this.hidden : '';
			this.str += '<div class="tp-powered-by '+ class_name +'" data-controll="powered-by">';
       //   this.str += '<span><a href="http://www.celeste-love.com" target="__blank">Powered By TrackingMore</a></span>';
			this.str += '</div>';
			return true;
		}
		
		// load top html
		loadTopHtml(){
			this.str += '<div class="tp-top-style1 an-shadow-style" data-visual="top-bar">';
			this.str += '<div class="tp-top-content">';
			if(this.progress_node.length > 0) this.loadTopProgress();
			// this.loadTopMobileProgress();
			this.str += '</div>';
			this.str += '</div>';
			return true;
		}
		
		// load mobile top progress
		loadTopMobileProgress(){
			let width = "100%";
			this.str += '<div class="tp-top-mobile-progress">';
			this.progress_node.forEach((v, k) => {
				return _self.loadMobileProgressItem(v);
			});
			this.str += '<div class="tp-mobile-progress-bar">';
			this.str += '<span style="height: '+ width +'"></span>'
			this.str += '</div>';
			this.str += '</div>';
			return true;
		}
		
		// load mobile progress item
		loadMobileProgressItem(v){
			let name = v.name ? v.name : "",
				time = v.time ? v.time : "",
				status = v.status ? v.status : 0,
				svg = v.svg ? v.svg : '';
			this.str += '<div class="tp-mobile-progress-item">';
			
			this.str += '<div class="tp-mobile-progress-node">';
			this.str += '<span></span>';
			this.str += '</div>';
			
			this.str += '<div class="tp-mobile-progress-icon">';
			this.str += '<span>'+ svg +'</span>';
			this.str += '</div>';
			
			this.str += '<div class="tp-mobile-progress-content">';
			
			this.str += '<div class="tp-mobile-progress-name">';
			this.str += '<span>'+ name +'</span>';
			this.str += '</div>';
			
			this.str += '<div class="tp-mobile-progress-time">';
			this.str += '<span>'+ time +'</span>';
			this.str += '</div>';
			
			this.str += '</div>';
			
			this.str += '</div>';
			return true;
		}
		
		// load top progress
		loadTopProgress(){
			this.str += '<div class="tp-top-progress">';
			this.progress_node.forEach((v, k) => {
				return _self.loadProgressItem(v,k);
			});
			let width = this.getProgressWidth();
			this.str += '<div class="tp-top-progress-bar">';
			this.str += '<span class="tp-progress-bar-width' + this.progress_key +'" style="width: '+ width +'%"></span>'
			this.str += '</div>';
			this.str += '</div>';
			return true;
		}
		
		// get progress width by tracking status
		getProgressWidth(node){
			let width;
			let over_width = 5;
			let len = this.progress_node.length;
			let flex_all = 0;
			let flex_width = 0;
			let flex_width_arr = [];
			while(len --){
				let flex1 = parseInt(this.progress_node[len].flex);
				if(!isNaN(flex1)) flex_all += flex1;
			}
			for(let i = 0; i < this.progress_node.length; i ++){
				if(i === 0){
					flex_width = over_width;
				}else{
					let flex1 = parseInt(this.progress_node[i-1].flex);
					if(!flex1) continue;
					flex_width += Math.floor(flex1 * 100 / flex_all) + over_width;
					if(flex_width > 100) flex_width = 100;
				}
				flex_width_arr.push(flex_width);
			}
			return flex_width_arr[this.progress_key] ? flex_width_arr[this.progress_key] : 0;
		}
		
		// load top progress item
		loadProgressItem(v, k){
			let name = v.name ? v.name : "",
				time = v.time ? v.time : "",
				status = v.status ? v.status : 0,
				svg = _self.svgAllList[status] ? _self.svgAllList[status] : '',
				style = v.flex ? "flex : " + v.flex + ";" : "text-align: right",
				style1 = v.flex ? "" : "float: right",
				class_name = k <= this.progress_key ? '' : 'tp-progress-disabled';
			this.str += '<div class="tp-top-progress-item '+ class_name +'" style="'+ style +'">';
			
			this.str += '<div class="tp-top-progress-icon">';
			this.str += svg;
			this.str += '</div>';
			
			this.str += '<div class="tp-top-progress-node">';
			this.str += '<span style="'+ style1 +'"></span>';
			this.str += '</div>';
			
			this.str += '<div class="tp-top-progress-name">';
			this.str += '<span data-controll="status-'+ status +'">'+ name +'</span>';
			this.str += '</div>';
			
			this.str += '<div class="tp-top-progress-time">';
			this.str += '<span>'+ time +'</span>';
			this.str += '</div>';
			
			this.str += '</div>';
			return true;
		}
		
		// load middle html
		loadMiddleHtml(item){
			this.str += '<div class="tp-middle-style1">';
			// load middle list
			while(item --) this.loadMiddelList(item);
			this.str += '</div>';
			return true;
		}
		
		// load middle list
		loadMiddelList(item){
	//		this.str += '<div class="tp-middle-list">';
	//		this.str += '<div class="tp-middle-content">';
			switch(item){
				case 2 : this.loadMiddle1List(); break;
				case 1 : this.loadMiddle2List(); break;
				case 0 : break;
				default : break;
			}
			this.str += '</div>';
			this.str += '</div>';
			return true;
		}
		
		// load middle three
		loadMiddle3List(){
			let item = 2;
			let url = this.url_list[item] ? this.url_list[item] : 'javascript:;';
			let class_name = this.url_list[item] ? '' : this.cursor_defalt;
			this.str += '<div class="tp-middle-right an-shadow-style" data-visual="asset">';
			this.str += '<a href="'+ url +'" class="tm64-images '+ class_name +' tm64-images-'+ item +'" data-controll="images-'+ item +'" target="__blank" data-visual="asset'+ item +'">';
			// theme 2 load theme button
			if(this.theme === 2){
				this.str += '<div class="tm64-images-button">';
				this.str += '<a class="tp-main-button" href="/" target="__blank">';
				this.str += this.translate.shop_latest;
				this.str += '</a>';
				this.str += '</div>';
			}
			this.str += '</a>';
			this.str += '</div>';
			return true;
		}
		
		// load middle second
		loadMiddle2List(){
			switch(this.theme){
				case 1 : return this.loadMiddle2List1Theme(); break;
				case 2 : return this.loadMiddle2List2Theme(); break;
				default : return false; break;
			}
			return false;
		}
		
		// load middle second theme 2
		loadMiddle2List2Theme(){
		
			// load tracking info list
			this.loadTrackingInfoList();
			
			return true;
		}
		
		// load middle second theme 1
		loadMiddle2List1Theme(){
			this.str += '<div class="tp-middle-center">';
			
			let item = 1;
			let url = this.url_list[item] ? this.url_list[item] : 'javascript:;';
			let class_name = this.url_list[item] ? '' : this.cursor_defalt;
			
			// bottom start
			this.str += '<div class="tp-middle-center-bottom">';
			
			// get review stars
			this.getReviewStars(5);
			
			this.str += '</div>';
			
			this.str += '</div>';
			return true;
		}
		
		// get review stars
		getReviewStars(item){
			this.str += '<div class="tp-review-parent an-shadow-style tp-box-shadow tp-card-style1" data-visual="help-us-improve">';
			
			this.str += '<div class="tp-leader-title">';
			this.str += '<span class="tp-f-h-1" data-controll="help_us_improve">' + this.translate.help_us_improve + '</span>';
			this.str += '</div>';
			
			this.str += '<div class="tp-card-content tp-table-parent">';
			this.str += '<div class="tp-table-child tp-p-0-8">';
			
			// review start
			let class_name = this.ratedstars === 1 ? this.thanks_show : '';
			this.str += '<div class="tp-review-content '+ class_name +'">';
			
			this.str += '<div class="tp-review-rate">';
			while(item --) {
				this.str += '<span onclick="return tpStarsAllFunction(this,event,0,'+ item +');" onmouseout="return tpStarsAllFunction(this,event,1,'+ item +');" onmouseover="return tpStarsAllFunction(this,event,2,'+ item +');" data-class="tp-review-svg-full">';
				this.str += '<svg style="height: 30px;width:30px" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M5.2 18a.8.8 0 0 1-.47-.152.8.8 0 0 1-.322-.762l.743-5.203-2.917-2.917a.8.8 0 0 1-.196-.81.798.798 0 0 1 .63-.544l4.398-.734 2.218-4.435a.808.808 0 0 1 .72-.443.8.8 0 0 1 .715.45l2.123 4.362 4.498.801a.8.8 0 0 1 .623.547.798.798 0 0 1-.198.806l-2.917 2.917.744 5.203a.8.8 0 0 1-.327.764.799.799 0 0 1-.827.064l-4.382-2.22-4.502 2.223A.792.792 0 0 1 5.2 18zm1.51-2.884l3.357-1.658.892.452 2.327 1.178-.56-3.912.708-.707 1.29-1.29-3.234-.576-.446-.915-1.06-2.176L8.4 8.683l-1.005.168-2.098.35 1.975 1.975-.141.99-.421 2.95z"></path></svg>';
				this.str += '<svg style="height: 30px;width:30px" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M5.2 18a.8.8 0 0 1-.47-.152.8.8 0 0 1-.322-.762l.743-5.203-2.917-2.917a.8.8 0 0 1-.196-.81.798.798 0 0 1 .63-.544l4.398-.734 2.218-4.435a.808.808 0 0 1 .72-.443.8.8 0 0 1 .715.45l2.123 4.362 4.498.801a.8.8 0 0 1 .623.547.798.798 0 0 1-.198.806l-2.917 2.917.744 5.203a.8.8 0 0 1-.327.764.799.799 0 0 1-.827.064l-4.382-2.22-4.502 2.223A.792.792 0 0 1 5.2 18z"></path></svg>';
				this.str += '</span>';
			}
			this.str += '</div>';
			
			this.str += '<div class="tp-review-title tp-p-t-8">';
			this.str += '<span data-controll="rate_shipping">' + this.translate.rate_shipping + '</span>';
			this.str += '</div>';
			
			this.str += '<div class="tp-review-thanks">';
			
			this.str += '<div class="svg-main-color">';
			this.str += '<svg style="height: 35px;width: 35px" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M10 0C4.486 0 0 4.486 0 10s4.486 10 10 10 10-4.486 10-10S15.514 0 10 0m0 18c-4.411 0-8-3.589-8-8s3.589-8 8-8 8 3.589 8 8-3.589 8-8 8M7 9a1 1 0 1 0 0-2 1 1 0 0 0 0 2m6-2a1 1 0 1 0 0 2 1 1 0 0 0 0-2m-.696 4.281c-.03.03-.786.72-2.304.72-1.497 0-2.252-.67-2.303-.718a1 1 0 0 0-1.404 1.424C6.425 12.84 7.653 14 10 14c2.346 0 3.575-1.16 3.707-1.293a.993.993 0 0 0 .005-1.397 1.006 1.006 0 0 0-1.408-.029"/></svg>';
			this.str += '</div>';
			this.str += '<div class="tp-p-t-8">';
			this.str += '<span data-controll="rate_thanks">' + this.translate.rate_thanks + '</span>';
			this.str += '</div>';
			
			this.str += '</div>';
			
			this.str += '</div>';
			
			// review end
			
			this.str += '</div>';
			this.str += '</div>';
			
			this.str += '</div>';
			return true;
		}
		
		// review rate stars
		reviewRateStars(r,i){
			let params = "type=rate-stars&review="+ this.review +"&ratedstars="+ this.ratedstars +"&stars=" + i;
			this.sendApiRequest(this.getDataToParams(params,true),"get","",function(res){
				return _self.hanleRateStars(r,res);
			});
		}
		
		// handle review result
		hanleRateStars(r,res){
			let code = res.code ? parseInt(res.code) : 0;
			if(code === 200) r.parentNode.parentNode.classList.add(this.thanks_show);
			return true;
		}
		
		// load middle first theme 1
		loadMiddle1List1Theme(){
			this.str += '<div class="tp-middle-left">';
			
			// top start =====
			if(this.estimated.length > 0) this.loadEstimatedDelivery();
			// top end =====
			
			// bottom start =====
			
			// load tracking info list
			this.loadTrackingInfoList();
			// bottom end =====
			
			this.str += '</div>';
			
			return true;
		}
		
		// load tracking info list
		loadTrackingInfoList(){
			
			let class_name = this.theme === 1 ? 'tp-middle-bottom ' : '';
			class_name += this.estimated.length > 0 ? 'tp-card-style2' : 'tp-card-style3';
			
			this.str += '<div class="tp-tracking-history an-shadow-style tp-box-shadow '+ class_name +'" data-visual="tracking-history">';
			
			this.str += '<div class="tp-leader-title">';
			this.str += '<span class="tp-f-h-1" data-controll="travel_history">'+ this.translate.travel_history +' </span>';
			// this.str += '( <a href="">' + this.translate.view_details + '</a> )';
			this.str += '</div>';
			
			this.str += '<div id="'+ this.progress_parent +'" class="tp-p-12 tp-progress-bar-parent">'
			
			this.str += '<div id="'+ this.tracking_description +'" class="tp-p-b-12 tp-tracking-description">';
			this.str += '<span data-controll="please_note">'+ this.status_description +'</span>';
			this.str += '</div>';
			
			// If it is Firefox
			class_name = this.browser === 'Firefox' ? 'tp-progress-bar-firefox' : '';
			this.str += '<div id="'+ this.tracking_list +'" class="tp-middle-bottom-content tp-tracking-list '+ class_name +'">';
			// load progress bar and tracking
			this.loadProgressTracking();
			this.str += '</div>';
			
			// load tracking number and express
			if(this.express_name || this.tracking_number || this.translate.track_another) this.loadTrackingMessage();
			
			this.str += '</div>';
			
			this.str += '</div>';
			
			return true;
		}
		
		// load tracking number and express
		loadTrackingMessage(){
			let class_name = this.hide_list.join('').indexOf('123') > -1 ? this.hidden : '';
			this.str += '<div id="'+ this.history_fixed +'" class="tp-middle-bottom-fixed '+ class_name +'">';
			
			this.str += '<div class="tp-b-t-1 tp-p-t-8">';
			this.str += '</div>';
			
			class_name = this.isInArray(this.hide_list,'1') ? this.hidden : '';
			this.str += '<div data-controll="hide_courier" class="'+ class_name +'">';
			this.str += '<span>'+ this.express_name +' </span>';
			this.str += '</div>';
			
			class_name = this.isInArray(this.hide_list,'2') ? this.hidden : '';
			this.str += '<div data-controll="hide_number" class="'+ class_name +'">';
			this.str += '<span>'+ this.tracking_number +' </span>';
			this.str += '</div>';
			
			class_name = this.isInArray(this.hide_list,'3') ? this.hidden : '';
			this.str += '<div data-controll="hide_another" class="'+ class_name +'">';
			this.str += '<span><a href="javascript:;" onclick="return tpTrackingAnother(this,event);" data-controll="track_another">' + this.translate.track_another + '</a></span>';
			this.str += '</div>';
			
			this.str += '</div>';
			return false;
		}
		
		// load middle first theme 2
		loadMiddle1List2Theme(){
			this.str += '<div class="tp-middle-left">';
			// top start =====
			if(this.estimated.length > 0) this.loadEstimatedDelivery();
			// top end =====
			
			// bottom start =====
			this.str += '<div class="tp-middle-bottom">';
			// get review stars
			this.getReviewStars(5);
			this.str += '</div>';
			// bottom end =====
			
			this.str += '</div>';
			return true;
		}
		
		// load estimated delivery
		loadEstimatedDelivery(){
			this.str += '<div class="tp-middle-top an-shadow-style tp-card-style1 tp-box-shadow" data-visual="estimated-delivery">';
			
			this.str += '<div class="tp-leader-title">';
			this.str += '<span class="tp-f-h-1" data-controll="estimated_delivery">'+ this.translate.estimated_delivery +'</span>';
			this.str += '</div>';
			
			this.str += '<div class="tp-card-content tp-table-parent">';
			
			this.str += '<div class="tp-table-child tp-p-0-8">';
			// estimated exsit or not exsit
			this.estimated.length > 0 ? this.loadEstimatedExsit() : this.loadEstimatedNotExsit();
			this.str += '</div>';
			
			this.str += '</div>';
			
			this.str += '</div>';

			return true;
		}
		
		// load Estimated list
		loadEstimatedExsit(){
			this.str += '<div class="tp-calendar-parent">';
			this.estimated.forEach((v,k) => {
				return _self.loadCalendarList(v,k);
			});
			this.str += '</div>';
			return false;
		}
		
		// load Estimated list
		loadEstimatedNotExsit(){
			return this.loadNoDataTips(_self.translate.no_estimated_delivery);
		}
		
		// Load Calendar List 
		loadCalendarList(v,k){
			if(!v.week || !v.month) return false;
			let class_name = k === 1 ? 'tp-t-a-r' : 'tp-t-a-l';
			this.str += '<div class="tp-calendar-list">';
			this.str += '<div class="tp-calendar-style '+ class_name +'">';
			this.str += '<div class="tp-calendar-week">';
			this.str += '<span data-controll="MF-'+ v.weeken +'">'+ v.week +'</span>';
			this.str += '</div>';
			this.str += '<div class="tp-calendar-month">';
			this.str += '<span>'+ v.month +'</span>';
			this.str += '</div>';
			this.str += '<div class="tp-calendar-day">';
			if(k === 1) this.str += '<span class="tp-calendar-to">-</span>';
			this.str += '<span>'+ v.day +'</span>';
			this.str += '</div>';
			this.str += '</div>';
			this.str += '</div>';
			return true;
		}
		
		// load middle first
		loadMiddle1List(){
			switch(this.theme){
				case 1 : return this.loadMiddle1List1Theme(); break;
				case 2 : return this.loadMiddle1List2Theme(); break;
				default : return false; break;
			}
			return false;
		}
		
		loadProgressTracking(){
			var len = this.info.length;
			let class_name = len === 0 ? 'tp-table-parent' : '';
			this.str += '<div class="tp-progress-bar '+ class_name +'">';
			// right content
			this.str += '<div class="tp-progress-item-parent tp-table-child">';
			// load no tracking information
			if(len === 0) {
				// this.loadNoDataTips('No such logistics information')
			}
			// load tracking information
			else{
				for(var i = 0; i < len; i ++) this.loadTrackingInfo(i, len);
			}
			this.str += '</div>';
			this.str += '</div>';
			return true;
		}
		
     
		// no tracking info
		loadNoDataTips(message){
			this.str += '<div class="tp-not-found">';
			this.str += '<div class="svg-main-color">';
			this.str += '<svg style="height: 35px;width: 35px" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M10 0C4.486 0 0 4.486 0 10s4.486 10 10 10 10-4.486 10-10S15.514 0 10 0m0 18c-4.411 0-8-3.589-8-8s3.589-8 8-8 8 3.589 8 8-3.589 8-8 8M7 9a1 1 0 1 0 0-2 1 1 0 0 0 0 2m6-2a1 1 0 1 0 0 2 1 1 0 0 0 0-2m0 5H7a1 1 0 1 0 0 2h6a1 1 0 1 0 0-2"/></svg>';
			this.str += '</div>';
			this.str += '<div class="tp-p-t-8">';
			this.str += '<span>'+ message +'</span>';
			this.str += '</div>';
			this.str += '</div>';
			return true;
		}
      
	
		// load tracking info -- remove keywords here
		loadTrackingInfo(item, len){
			let last_class_name = len === 1 || item !== len - 1 ? '' : 'tp-progress-item-last',
				tracking_info = this.info[item] ? this.info[item] : {},
				tracking_time = tracking_info.time ? tracking_info.time : '',
				tracking_event = tracking_info.event ? tracking_info.event : '',
				tracking_local = tracking_info.local ? tracking_info.local : '';
			let remove_words = ['HEATHROW ','Huizhou',",", "CN.Shanghai", "4PX", "ShaTian", "China", "Yanwen", "CAN /", "Shanghai", "Baiyun", "Guangzhou", "Pudong", "CN", "CN.", "HKG", "Shenzhen", "SZX", "Hong Kong", "GZ", " pudong", "cn", "hkg", "\'CN.\'", "hong kong", "hongkong", "hk" ,"CGO", "guangdong", "深东凤岗仓", "深东凤岗仓", "深东凤岗仓"];
			if(tracking_local) tracking_event += ", " + tracking_local;
			if(!tracking_time) return false;

            for (let i = 0; i < remove_words.length; i++) {
                let word_regex = new RegExp(remove_words[i], "gi");
                tracking_event = tracking_event.replace(word_regex, "");
            }
			this.str += '<div class="tp-progress-item '+ last_class_name +'">';
			if(len > 1) this.str += '<div class="tp-progress-item-bar"></div>';
			this.str += '<span class="tp-progress-item-node"></span>';
			this.str += '<div class="tp-progress-time">';
			this.str += '<span>'+ tracking_time +'</span>';
			this.str += '</div>';
			this.str += '<div class="tp-progress-info" >';
			this.str += '<span>'+ tracking_event +'</span>';
			this.str += '</div>';
			this.str += '</div>';
			return true;
		}
      

		
		// load bottom html
		loadBottomHtml(item){
			let class_name = this.checkBottomImg(item) ? this.hidden : '';
			this.str += '<div class="tp-bottom-style '+ class_name +'">';
			// load bottom list
			while(item --) this.loadBottomList(item);
			this.str += '</div>';
			// user custom text
		//	this.str += '<div class="tp-bottom-style1 an-shadow-style" data-visual="footer">';
	//		this.str += '<div class="tp-custom-text">';
	//		this.str += '<span data-controll="custom-text">'+ this.custom_text +'</span>';
			this.str += '</div>';
			// Powered By
			this.loadPoweredBy();
			this.str += '</div>';
			return true;
		}
		
        
        
		// check img is all hidden
		checkBottomImg(item){
			while(item --) if(this.isInArray(this.img_list,(5 - item))) return false;
			return true;
		}
		
		// load bottom left middle bottom
		loadBottomList(item){
			item = 5 - item
			let class_name = this.isInArray(this.img_list,item) ? '' : this.hidden;
			class_name += item === 5 ? ' tp-bottom-last-item' : '';
			let url = this.url_list[item] ? this.url_list[item] : 'javascript:;';
			let class_name1 = this.url_list[item] ? '' : this.cursor_defalt;
			this.str += '<div class="tp-bottom-list '+ class_name +'">';
			this.str += '<div class="tp-bottom-content tp-card-style5 an-shadow-style" data-visual="asset">';
			this.str += '<a href="'+ url +'" class="tm64-images '+ class_name1 +' tm64-images-'+ item +'" data-controll="images-'+ item +'" target="__blank" data-visual="asset'+ item +'">';
			this.str += '</a>';
			this.str += '</div>';
			this.str += '</div>';
			return true;
		}
		
		// When responding normally
		showSuccessPage(d){
			let str = "";
			// ------- tracking page top start -------
			str += '<div class="tp-top-style">';
			str += '<div class="tp-form-style-parent">';
			str += '<div class="tp-form-style">';
			str += '<div class="tp-item-input-parent">';
			
			// input order number
			str += '<div class="tp-item-input-style">';
			str += '<input name="number" placeholder="Order Number" />';
			str += '<span class="tp-item-input-error">please input your number</span>';
			str += '</div>';
			
			// input email
			str += '<div class="tp-item-input-style">';
			str += '<input name="email" placeholder="Email" />';
			str += '<span class="tp-item-input-error">please input your email</span>';
			str += '</div>';
			
			// tracking button
			str += '<div class="tp-item-button-style">';
			str += '<button type="button">Track</button>';
			str += '</div>';
			
			// change tracking way
			str += '<div class="tp-tabs-style">';
			str += '<span class="tp-item-tabs-style" data-number="Recherche par num" data-email="Recherche par email">Recherche par num</span>';
			str += '</div>';
			
			str += '</div>';
			str += '</div>';
			str += '</div>';
			str += '</div>';
			// ------- tracking page top end -------
			
			// ------- tracking page footer start -------
			str += '<div class="tp-footer-style">';
			str += '<div class="tp-item-image-parent">';
			
			// first image
			str += '<div class="tp-item-image-list">';
			str += '<div class="tp-item-image-style" style="background-image:url(\'http://download.trackingmore.com/upload/images/1.jpg\')"></div>';
			str += '</div>';
			
			// second image
			str += '<div class="tp-item-image-list">';
			str += '<div class="tp-item-image-style" style="background-image:url(\'http://download.trackingmore.com/upload/images/1.jpg\')"></div>';
			str += '</div>';
			
			// third image
			str += '<div class="tp-item-image-list">';
			str += '<div class="tp-item-image-style" style="background-image:url(\'http://download.trackingmore.com/upload/images/1.jpg\')"></div>';
			str += '</div>';
			
			str += '</div>';
			str += '</div>';
			// ------- tracking page footer end -------
			
			// Mount to the specified element
			this.tp.innerHTML = str;
			return true;
		}
		
		// When not responding properly
		showErrorResponse(c,m){
			console.log(m);
			return true;
		}
		
		// Get page preparation parameters
		getDataToParams(type, bool){
			if(!type) return "";
			let arr = [];
			arr.push(type);
			if(this.key) arr.push("key=" + this.key);
			if(!bool){
				if(this.num) arr.push("tracking_number=" + this.num);
				if(this.ord) arr.push("order=" + this.ord);
				if(this.email) arr.push("email=" + this.email);
			}
			return u + p + "?" + arr.join("&");
		}
		
		// Load different styles based on the current main div width
		loadStyleByWidth(width){
			var dom = t.getElementById(tp),
				width = dom.clientWidth,
				item;
			if(width > 1199){
				item = 1399;
			}
			else if(width <= 1199 && width > 997){
				item = 1199;
			}
			else if(width <= 997 && width > 767){
				item = 997;
			}
			else if(width <= 767 && width > 600){
				item = 767;
			}
			else{
				item = 600;
			}
			this.width_class.forEach(function(v,k,self){
				if(v.width == item && !_self.isHasClassFun(dom,v.name)){
					dom.classList.add(v.name);
					if(width <= 600){
						let name = self[1].name;
						if(!_self.isHasClassFun(dom,name)) dom.classList.add(name);
					}
				}
				if(v.width != item && _self.isHasClassFun(dom,v.name) && width > 600) dom.classList.remove(v.name);
			});
			return true;
		}
		
		// Monitor page width
		monitorPageWidth(time){
			_self.loadStyleByWidth();
			w.onresize = function(){
				if(time) clearTimeout(time);
				time = setTimeout(function(){
					_self.loadStyleByWidth();
				},10);
			}
		}
		
		// change location url
		changeLocationUrl(){
			let hostname = u.replace(/\//g,"")
			if(w.location.host != hostname) return false;
			let url = w.location.href;
			let length = url.length;
			let index = url.indexOf('/' + this.track_url);
			let value = url.substring(index, length);
			value = hostname + value;
			let replaceText = hostname + '/' + this.track_url;
			if(this.tracking_number) replaceText += '/' + this.tracking_number;
			url = url.replace(value,replaceText);
			if(value != replaceText) w.history.pushState({},t.title,url);
		}
		
		// get url params
		getUrlParams(){
			let url = w.location.href;
			let where = url.substr(url.indexOf("?")+1);
			let where_arr = where ? where.split("&") : [];
			let arr;
			let where_arr_new = {};
			if(where_arr.length > 0){
				for(var i = 0 ; i < where_arr.length ; i ++){
					arr = where_arr[i].split('=');
					if(arr[0] && this.isInArray(this.trackingParams,arr[0])) where_arr_new[arr[0]] = arr[1];
				}
			}
			return where_arr_new;
		}
		
		// get url last value
		getUrlLastValue(url){
			var site = url.lastIndexOf("\/");
			return url.substring(site + 1, url.length);
		}
		
		// change location para
		changeLocationPara(arg,arg_val) {
			let url = w.location.href;
			let title = t.title;
			let pattern = arg+'=([^&]*)';
			let pattern1 = /[&?]$/;
			let pattern2 = /([&?])&/;
			let replaceText = arg+'='+arg_val;
			if(arg_val === '') replaceText = '';
			let newUrl = url.match(pattern) ? url.replace(eval('/('+ arg+'=)([^&]*)/gi'),replaceText) : url.match('[?]') ? url+'&'+replaceText : url+'?'+replaceText;
			if(replaceText === '' && newUrl.match(pattern1)) newUrl = newUrl.replace(pattern1,'');
			if(newUrl.match(pattern2)) newUrl = newUrl.replace(pattern2,'$1');
			w.history.pushState({},title,newUrl);
			return newUrl;
		}
		
		// load css file and custom style
		appendCssLinkStyle(value){
			if(!value) return false;
			let h = t.getElementsByTagName('head')[0];
			if(!/^http/.test(value)){
				var l = t.createElement("style");
				l.innerHTML = value;
				return h.appendChild(l);
			}
			var l = t.createElement("link");
			l.type = "text/css";
			l.rel = "stylesheet";
			l.href = value;
			return h.appendChild(l);
		}
		
		// is in array
		isInArray(arr, value){
			for(let i = 0; i < arr.length; i++) if(value == arr[i]) return true;
			return false;
		}
		
		// Checks if element contains a class
		isHasClassFun( element, cls){
			return (' ' + element.className + ' ').indexOf(' ' + cls + ' ') > -1;
		}
		
		// Urlencode and trim
		trimEncode(s){
			if(!s) return s;
			s = (s + '').toString();
			s = s.replace(/(^\s*)|(\s*$)/g, "");
			return encodeURIComponent(s).replace(/!/g, '%21').replace(/'/g, '%27').replace(/\(/g, '%28').replace(/\)/g, '%29').replace(/\*/g, '%2A').replace(/%20/g, '+');
		}
		
		// Send api request
		sendApiRequest(u,m,d,f){
			let x = "";
			m = m != "get" && m != "post" ? "get" : m;
			d = d || null;
			f = f || "";
			if(!d || Object.keys(d).length === 0) d = null, m = "get";
			if(!u) return false;
			try{
				x = new XMLHttpRequest();
			}catch(e){
				try{
					x = new ActiveXObject("Msxml2.XMLHTTP");
				}catch(e){
					try{
						x = new ActiveXObject("Microsoft.XMLHTTP");
					}catch(e){
						console.log("Failed to get ajax object, please contact customer service for a solution!");
					}
				}
			}
			if(!x) return false;
			x.onreadystatechange = function(){
				// try{
					if(x.readyState == 4 && (x.status == 200 || x.status == 304)){
						var d = x.responseText;
						d = d ? JSON.parse(d) : {};
						if(f !== "") f(d);
					}
				// }catch(e){
				// 	console.log("Ajax response is error, please contact customer service for a solution!");
				// }
			}
			x.open(m,u);
			x.send(d);
		}
	}
	
	// Use trackingmore
	let tm = new trackingmore();
	// Load the tracking page
	tm.showTracking();
	
	tpStarsAllFunction = function(r,e,w,i){
		var name = r.getAttribute("data-class"),
			child = r.parentNode.children;
		e.stopPropagation();
		i = 5 - i;
		switch(w){
			case 0 : tm.reviewRateStars(r,i); break;
			case 1 : while(i --) child[i].classList.remove(name); break;
			case 2 : while(i --) child[i].classList.add(name); break;
			default : break;
		}
	}
	
	tpSelectTracking = function(r,e){
		return tm.selectTracking(r,e);
	}
	
	tpSubmitForm = function(r,e){
		return tm.submitForm(r,e);
	}
	
	tpTrackingAnother = function(r,e){
		return tm.trackingAnother(r,e);
	}
	
	tploadStyleByWidth = function(){
		return tm.loadStyleByWidth();
	}
	
	tpPageCommunication = function(q,...params){
		return tm.pageCommunication(q,params);
	}
	
}(window,document,"//t.trackingmore.com","/api.php","//s.trackingmore.com","tm-my-tp-container",{}))